import React from "react";
import ReactDOM from "react-dom/client";
import { initSentry, Sentry } from "@/sentry";
import "@/index.css";
import App from "@/App";

// Init BEFORE React mounts so even first-render errors are captured.
initSentry();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      fallback={({ resetError }) => (
        <div
          style={{
            minHeight: "100vh",
            background: "#050505",
            color: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "Manrope, system-ui, sans-serif",
            padding: "24px",
          }}
        >
          <div style={{ maxWidth: 480, textAlign: "center" }}>
            <p
              style={{
                color: "#D4AF37",
                letterSpacing: "0.25em",
                fontSize: 11,
                marginBottom: 12,
              }}
            >
              EQUIA · UNEXPECTED ERROR
            </p>
            <h1
              style={{
                fontFamily: "Playfair Display, Georgia, serif",
                fontWeight: 400,
                fontSize: 26,
                marginBottom: 14,
              }}
            >
              Something went sideways
            </h1>
            <p
              style={{
                color: "rgba(255,255,255,0.55)",
                fontSize: 14,
                lineHeight: 1.6,
                marginBottom: 24,
              }}
            >
              Our team has been notified automatically. You can try reloading
              this page — your data is safe.
            </p>
            <button
              onClick={() => {
                resetError();
                window.location.reload();
              }}
              style={{
                background: "#D4AF37",
                color: "#0A0A0A",
                border: 0,
                padding: "12px 28px",
                fontSize: 12,
                letterSpacing: "0.15em",
                textTransform: "uppercase",
                cursor: "pointer",
                fontWeight: 600,
              }}
            >
              Reload App
            </button>
          </div>
        </div>
      )}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
);

// Register the PWA service worker — only in production builds. In dev we want
// hot-module reload to never be cached. Failures are silent because SW is
// progressive enhancement; the app must work without it.
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}
